import { AgPickerField } from 'ag-grid-community/dist/lib/widgets/agPickerField';
import { IApiFile } from '../modals/model/file-preview.interface';

export enum SUPPORTED_FILE_TYPES {
    TEXT_FILE = "TEXT_FILE",
    IMAGE_FILE = "IMAGE_FILE",
    PDF_FILE = "PDF_FILE",
}

export const TEXT_FILE_EXTENSIONS = "txt,asc,bed,gff,gff3,fastq,vcf,csv,xml,tab,tsv,html,xml,xhtml,log,json,sql,yaml";
export const IMAGE_FILE_EXTENSIONS = "jpg,jpeg,gif,png";
export const PDF_FILE_EXTENSIONS = "pdf";
export const PREVIEW_BYTE_MAX = 5242880;

export interface IRequestedFile extends IApiFile {
    extension: string;
}

export interface FilePreviewComponentOutput {
    downloadLink: string;
}
